<template>
  <v-layout v-if="show">
    <!-- <v-chart :style="style" :options="charts"/> -->
    <v-card flat :style="style" class="px-8"> 
      <div v-for="(item,index) in notChartData" :key="index">
        <v-layout row wrap >
          <div>{{index+1}}.</div>
          <div class="pl-2">{{item.name}}</div> 
          <!-- :
          <div class="pl-5">{{item.value}}</div>  -->
        </v-layout>
      </div> 
    </v-card>
  </v-layout>
</template>

<script> 
export default {
  props:["not","notShow","notChartType","notUnit","notHeight","notWidth","notColors","notChartData"],
  data: () => ({
    show:false,  
  }),
  mounted() { 
    console.log(this.notChartData,'..............');
    this.show = false
      setTimeout(() => {
        this.show = this.notShow
      }, 100); 
  },
  computed: {
    vs(){
      return this.not.vs
    },
    vs_width(){
      return this.vs.width
    },
    style(){
      let h = "400px"
      let w = "100%"
      if (this.notWidth) {
        w = this.notWidth
      }
      if (this.notHeight) {
        h=this.notHeight
      }
      return "width: "+w+"; height:"+h+"; overflow: auto;"
    },
    charts(){ 
      let data =   this.notChartData
      if (this.notUnit==="Percentage") {
        data = this.percentage(data)
      }else if (this.notUnit==="%") {
        data = this.percentage(data)
      }
      let chartData = this.combination(data) 
      let ch = this.processChart(chartData)
      return ch
    }, 

  },
  methods:{ 
    // combination(chartData){
    //     if (!chartData) {return null} 
    //     let labels = []
    //     chartData.forEach(it => {
    //       labels.push(it.name)
    //     }); 
    //     return {
    //       labels:labels,
    //       collection:chartData
    //     };
    // }
  },
  watch: {
    notShow(v){
      this.show =v
    },
    notHeight(v){
      this.show = false
      setTimeout(() => {
        this.show = this.notShow
      }, 100); 
    },
    notChartData(v){ 
      // this.show = false
      // setTimeout(() => {
      //   this.show = this.notShow
      // }, 100); 
    },
    vs_width(v){
      this.show = false
      setTimeout(() => {
        this.show = this.notShow
      }, 100); 
    }
  },
};
</script>
